import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, TextInput, Button, Create, SimpleForm, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, NumberInput, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, DateField, Filter, downloadCSV, DateInput } from 'react-admin';import jsonExport from 'jsonexport/dist';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import GavelIcon from '@material-ui/icons/Gavel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { dateOnlyToCatalan } from './../common/utils';  

import { ExportButton } from './../components/ExportButton';

import { Link } from 'react-router-dom';

import { validateMaxLength } from './../components/Validator';export const BookingsItemsList = (props) => {
  const translate = useTranslate();  
    
  let basePath='/bookings_items'; 
  let resource = 'bookings_items';
  let strRedirect = 'bookings_items';
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ associations_id : localStorage.getItem('associations_id') }}  
        actions={props.show ?  <span/> : <ListActions />}    
        empty={props.show ?  <span/> : <ListActions />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'id', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={props.show ?  <span/> : <MyFilter />} 
        filterDefaultValues={ { q: "" }}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<BookingsItemsDetails />} >  
          <Avatar><GavelIcon/></Avatar>                                  
          <TextField source="bookings_id" label={translate('bookings_items.bookings_id')} sortable={false} />  
          <TextField source="events_sessions_id" label={translate('bookings_items.events_sessions_id')} sortable={false} />  
          <TextField source="zones_id" label={translate('bookings_items.zones_id')} sortable={false} />  
          <TextField source="seats_id" label={translate('bookings_items.seats_id')} sortable={false} />  
          <TextField source="tickets_fares_id" label={translate('bookings_items.tickets_fares_id')} sortable={false} />  
          <TextField source="price_ticket_base" label={translate('bookings_items.price_ticket_base')} sortable={false} />  
          <TextField source="price_ticket_iva" label={translate('bookings_items.price_ticket_iva')} sortable={false} />  
          <TextField source="price_ticket_total" label={translate('bookings_items.price_ticket_total')} sortable={false} />  
          <TextField source="price_management_base" label={translate('bookings_items.price_management_base')} sortable={false} />  
          <TextField source="price_management_iva" label={translate('bookings_items.price_management_iva')} sortable={false} />  
          <TextField source="price_management_total" label={translate('bookings_items.price_management_total')} sortable={false} />  
          <TextField source="price_total" label={translate('bookings_items.price_total')} sortable={false} />  
          <TextField source="status" label={translate('bookings_items.status')} sortable={false} />  
          <TextField source="qr_code" label={translate('bookings_items.qr_code')} sortable={false} />  
          <TextField source="serial_number" label={translate('bookings_items.serial_number')} sortable={false} />  
          <DateField source="created_at" label={translate('bookings_items.created_at')} sortable={false} />  
          <DateField source="updated_at" label={translate('bookings_items.updated_at')} sortable={false} />  
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const BookingsItemsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={4}>   
          <TextFieldShow source={record.bookings_id} label={translate('bookings_items.bookings_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.events_sessions_id} label={translate('bookings_items.events_sessions_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.zones_id} label={translate('bookings_items.zones_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.seats_id} label={translate('bookings_items.seats_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.tickets_fares_id} label={translate('bookings_items.tickets_fares_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_ticket_base} label={translate('bookings_items.price_ticket_base')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_ticket_iva} label={translate('bookings_items.price_ticket_iva')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_ticket_total} label={translate('bookings_items.price_ticket_total')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_management_base} label={translate('bookings_items.price_management_base')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_management_iva} label={translate('bookings_items.price_management_iva')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_management_total} label={translate('bookings_items.price_management_total')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.price_total} label={translate('bookings_items.price_total')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.status} label={translate('bookings_items.status')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.qr_code} label={translate('bookings_items.qr_code')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.serial_number} label={translate('bookings_items.serial_number')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.created_at)} label={translate('bookings_items.created_at')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.updated_at)} label={translate('bookings_items.updated_at')} />
        </Grid> 
      </Grid>
      
    </div>
  );
};

const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: item.id,
        bookings_id: item.bookings_id,
        events_sessions_id: item.events_sessions_id,
        zones_id: item.zones_id,
        seats_id: item.seats_id,
        tickets_fares_id: item.tickets_fares_id,
        price_ticket_base: item.price_ticket_base,
        price_ticket_iva: item.price_ticket_iva,
        price_ticket_total: item.price_ticket_total,
        price_management_base: item.price_management_base,
        price_management_iva: item.price_management_iva,
        price_management_total: item.price_management_total,
        price_total: item.price_total,
        status: item.status,
        qr_code: item.qr_code,
        serial_number: item.serial_number,
        created_at: dateOnlyToCatalan(item.created_at),
        updated_at: dateOnlyToCatalan(item.updated_at),
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id','bookings_id'
,'events_sessions_id'
,'zones_id'
,'seats_id'
,'tickets_fares_id'
,'price_ticket_base'
,'price_ticket_iva'
,'price_ticket_total'
,'price_management_base'
,'price_management_iva'
,'price_management_total'
,'price_total'
,'status'
,'qr_code'
,'serial_number'
,'created_at'
,'updated_at'
],
    rename: [translate('common.id'),translate('bookings_items.bookings_id'),translate('bookings_items.events_sessions_id'),translate('bookings_items.zones_id'),translate('bookings_items.seats_id'),translate('bookings_items.tickets_fares_id'),translate('bookings_items.price_ticket_base'),translate('bookings_items.price_ticket_iva'),translate('bookings_items.price_ticket_total'),translate('bookings_items.price_management_base'),translate('bookings_items.price_management_iva'),translate('bookings_items.price_management_total'),translate('bookings_items.price_total'),translate('bookings_items.status'),translate('bookings_items.qr_code'),translate('bookings_items.serial_number'),translate('bookings_items.created_at'),translate('bookings_items.updated_at')],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('bookings_items.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};


const ListActions = (props) => {
    const translate = useTranslate(); 
    
    let filterExport = { 
        associations_id: localStorage.getItem('associations_id'),        
        q: props.filterValues && props.filterValues.q ? props.filterValues.q : ''
    };
    
    return (
    <TopToolbar>     
        <MyCreateButton {...props} />    
        <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={false} exporter={exporter} sort={{ field: 'id', order: 'DESC' }} /> 
    </TopToolbar>
    );
};

export const MyCreateButton = ({ users_id , ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('bookings_items');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          redirect('/bookings_items/' + data.id);
        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('bookings_items.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('bookings_items.create')}
      >
        <DialogTitle>{translate('bookings_items.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id') }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>                                     
                  <Grid item xs={12}>                                               
                    <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
  let linkBack = '/bookings_items';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const BookingsItemsEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  let strRedirect =  `/bookings_items/${id}`;    
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));        
    redirect('/bookings_items');        
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={3}>   
            <TextInput fullWidth source="bookings_id" label={translate('bookings_items.bookings_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="events_sessions_id" label={translate('bookings_items.events_sessions_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="zones_id" label={translate('bookings_items.zones_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="seats_id" label={translate('bookings_items.seats_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="tickets_fares_id" label={translate('bookings_items.tickets_fares_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_ticket_base" label={translate('bookings_items.price_ticket_base')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_ticket_iva" label={translate('bookings_items.price_ticket_iva')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_ticket_total" label={translate('bookings_items.price_ticket_total')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_management_base" label={translate('bookings_items.price_management_base')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_management_iva" label={translate('bookings_items.price_management_iva')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_management_total" label={translate('bookings_items.price_management_total')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <NumberInput fullWidth source="price_total" label={translate('bookings_items.price_total')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="status" label={translate('bookings_items.status')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="qr_code" label={translate('bookings_items.qr_code')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="serial_number" label={translate('bookings_items.serial_number')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="created_at" label={translate('bookings_items.created_at')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="updated_at" label={translate('bookings_items.updated_at')}  />
                  </Grid> 
                  <Grid item xs={12}>   
                  </Grid> 
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = ({ id , ...props }) => {
    
  let redirect = '/bookings_items';
    
    
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton redirect={redirect} mutationMode="pessimistic" />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});






export const BookingsItemsCreate  = ({ id, ...props }) => {

  const translate = useTranslate();   
  const [info, setInfo] = useState();
    
  return (

    <Create {...props} >
      <SimpleForm 
        initialValues={{ associations_id: localStorage.getItem('associations_id') }}
        redirect="list"
      >                
        <Grid container spacing={2}>
          <Grid item xs={12}>                    
            <Typography variant="h5" className="grey">{translate('bookings_items.create')}</Typography>
          </Grid>  
          <Grid item xs={11}>                    
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
          </Grid>          
        </Grid>   

      </SimpleForm> 
    </Create>
  );
};
